export function getDiagramAreaHW(mainHeight:number, mainWidth:number, editHeight:number, diagramPadding:number):any {
  //Calc new h/w value
  let diagramAreaHeight = mainHeight - (editHeight + (2 * diagramPadding));
  let diagramAreaWidth = mainWidth - (2 * diagramPadding);
  return { height: diagramAreaHeight, width: diagramAreaWidth}
}

